const getStrokeAnimationValue = ({
  strokeDuration, strokeEasing, strokeStaggerStep, strokeDelay, i,
}) => `animate-svg-stroke-${i + 1} ${strokeDuration}s ${strokeEasing} ${i * parseFloat(strokeStaggerStep) + parseFloat(strokeDelay)}s both`

export default getStrokeAnimationValue
